// NEW STYPEPARAMS METHOD
var ARROWS_POSITION = {
    ON_GALLERY: 'ON_GALLERY',
    OUTSIDE_GALLERY: 'OUTSIDE_GALLERY',
    MOUSE_CURSOR: 'MOUSE_CURSOR',
};
export default ARROWS_POSITION;
//# sourceMappingURL=layoutParams_navigationArrows_position.js.map